import httpClient from "@/config/httpClient";

export const swrMutator = async (url, options) => {
	const { arg } = options;

	const method = arg.method ?? "post";
	const payload = arg.payload ?? {};

	const fnc = httpClient[method].bind(httpClient);

	if (method === "delete") {
		return await fnc(url, {
			headers: {
				"Content-Type": "text/plain",
			},
		});
	}

	return await fnc(url, payload);
};
